<template>
  <div class="header-title">
    <div class="back" @click="back">
      <img src="../assets/images/home/back.png"/>
    </div>
    <div class="auto-hide">
      <span v-text="title"></span>
    </div>
    <div class="text-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderTitle',
  props: {
    title: {
      required: true,
      type: String
    },
    backPath: {
      type: String
    }
  },
  methods: {
    back () {
      if (this.$parent.feature) {
        this.$parent.feature = null
        return
      }
      if (this.backPath) {
        this.$router.push(this.backPath)
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.header-title {
  height: 45px;
  min-height: 45px;
  display: flex;
  padding: 0px 20px;
  align-items: center;
  justify-content: space-between;
  background-color: @base-white;
  font-size: 24px;
  font-weight: 600;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 2;
  color: rgba(38, 38, 38, 1);
  > div:last-child, div:first-child {
    width: 100px;
  }
  .back, img {
    height: 30px;
    cursor: pointer;
  }
}
</style>
